import React, { Component } from 'react'
// import { FormComponent } from '../../form/DynamicForm'
// import { Form, Validators } from '../../form/DynamicFormTs'
import { withRouter } from "react-router-dom";
import { Button, IconButton, Icon, TextField, Snackbar, Slide } from '@material-ui/core';
import Http from '../../../Http';
import { Validators } from '../../../components/form/DynamicFormTs';
// import Http from '../../../Http';

class Encargados extends Component {

  state = {
    encargados: [],
    sbOpen: false,
    sbMsg: '',
  }

  componentDidMount() {
    console.log(this.props.match)
    this.obtenerEncargados();
  }

  obtenerEncargados = async () => {
    const { match } = this.props;
    if (match.params.id) {
      try {
        let Res = await Http.get(`sucursal/${match.params.id}/encargados`);
        if (!Res.error) {
          this.setState({ encargados: Res.data.encargados });
        }
      } catch (error) {
        console.log(error)
      }
    }
    else {
      this.setState({ encargados: [] })
    }
  }

  agregarEncargado = () => {
    const { match } = this.props;
    let encargados = this.state.encargados;
    encargados.push({ id_sucursal: match.params.id, se_email: '' });
    // console.log(encargados)
    this.setState({ encargados })
  }

  guardarEncargados = async () => {
    const { match } = this.props;
    const { encargados } = this.state;
    console.log(encargados)

    if (encargados.some((encargado) => !Validators.email(encargado.se_email))) {
      this.setState({ sbMsg: 'Deben de ser correos válidos', sbOpen: true })
      return;
    }

    if (match.params.id) {
      try {
        let Res = await Http.post(`sucursal/${match.params.id}/encargados/save`, { encargados });
        console.log(Res)
        if (!Res.error) {
          this.setState({ sbMsg: 'Guardados', sbOpen: true })
        }
      } catch (error) {
        console.log(error)
      }
    }
    else {
      // this.setState({ encargados: [] })
    }
  }

  eliminarEncargado = async (i, encargado) => {
    if (encargado.id) {
      try {
        let Res = await Http.post('sucursal/encargado/delete', { id: encargado.id });
        if (!Res.error) {
          this.setState({ sbMsg: 'Eliminado', sbOpen: true })
          this.obtenerEncargados();
        }
      } catch (error) {

      }
    }
    else {
      let encargados = this.state.encargados.filter((enc, ie) => i !== ie);
      this.setState({ encargados })
    }
  }

  render() {
    const { encargados, sbOpen, sbMsg } = this.state;
    return (
      <div>
        <div style={{ flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
          <h4>Encargados de sucursal</h4>
          <Button onClick={this.agregarEncargado}>Agregar</Button>
        </div>
        <div>
          {encargados.map((encargado, i) => (
            <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 10, paddingLeft: 5, paddingRight: 5 }} key={i}>
              <div>
                <IconButton onClick={() => { this.eliminarEncargado(i, encargado) }}>
                  <Icon>remove_circle</Icon>
                </IconButton>
              </div>
              <div style={{ width: '100%' }}>
                <TextField
                  label="Correo electrónico"
                  fullWidth
                  value={encargado.se_email}
                  onChange={(e) => { let es = encargados; encargados[i].se_email = e.target.value; this.setState({ encargados: es }) }}
                  variant="outlined"
                />
              </div>
            </div>
          ))}
        </div>
        {
          encargados.length > 0 && (
            <div style={{ textAlign: 'right', paddingRight: 5 }}>
              <Button onClick={this.guardarEncargados}>Guardar encargados</Button>
            </div>
          )
        }
        <div>
          <Snackbar
            open={sbOpen}
            onClose={() => { this.setState({ sbOpen: false }) }}
            TransitionComponent={Slide}
            message={<span>{sbMsg}</span>}
          />
        </div>
      </div>
    )
  }
}

export default withRouter(Encargados)
